import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import Button from "../../../../components/form/Button";

import { DocumentTemplatesType } from "../../enum";

export const TemplatesDocument = (props) => {
  const columns = [
    {
      field: "type",
      label: "Typ šablony",
      type: ColumnType.ENUM,
      enum: DocumentTemplatesType,
      width: "10%",
    },
    {
      sortable: true,
      field: "validFrom",
      label: "Platnost od",
      type: ColumnType.DATE,
      width: "5%",
    },
    {
      sortable: true,
      field: "validTo",
      label: "Platnost do",
      type: ColumnType.DATE,
      width: "5%",
    },
    {
      sortable: true,
      field: "version",
      label: "Verze",
      type: ColumnType.TEXT,
      width: "5%",
    },
    {
      field: "published",
      label: "Aktivní",
      type: ColumnType.CHECK,
      width: "5%",
    },
    {
      field: "actions",
      disableOnRowClick: true,
      label: "Akce",
      type: ColumnType.JSX,
      width: "5%",
      sortable: false,
      jsx: (row) => {
        return (
            <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
            >
              <Button
                  className="grid-template-button"
                  label={row.published ? "Deaktivovat" : "Aktivovat"}
                  labelStyle={{fontSize: 10, padding: 5, display: "block"}}
                  style={{lineHeight: "auto", height: "auto"}}
                  onClick={() => row.published ? props.onDeactivateTemplate(row) : props.onActivateTemplate(row)}
              />
            </div>
        );
      },
    }
  ];

  return <CommonGrid {...props} columns={columns} />;
}


